<template>
  <div
    v-if="has_perm('view_liabilities_list') || GET_ACCOUNT_DATA.id == 1"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("accounting_home_liability.title") }}</b>
              <lte-button
                v-if="
                  has_perm('delete_liabilities_list') ||
                    GET_ACCOUNT_DATA.id == 1
                "
                style="float:right"
                type="btn
                            btn-danger"
                right_icon="glyphicon glyphicon-remove"
                @click="onShowModalDeleteLiability($event)"
                >{{ $t("common.delete_liability") }}</lte-button
              >
              <lte-button
                v-if="
                  has_perm('import_liabilities_list') ||
                    GET_ACCOUNT_DATA.id == 1
                "
                style="float:right"
                type="btn
                            btn-success"
                right_icon="fa fa-upload"
                @click="importExcel($event)"
                >{{ $t("customer.importExcel") }}</lte-button
              >

              <!-- delete liabiliites record -->
              <lte-button
                style="float:right"
                v-if="
                  has_perm('delete_liabilities_list') ||
                    GET_ACCOUNT_DATA.id == 1
                "
                type="btn
                            btn-warning"
                right_icon="fa
                            fa-minus-square"
                @click="onShowModalRemoveliabilitiesRecord()"
                >{{ $t("delete_abilities.button") }}</lte-button
              >
            </div>
          </div>

          <div class="box-body">
            <lte-table
              :hdBackground="hdBackground"
              :data="gridDataList"
              :columns="gridColumns"
              search_filter="left-search"
              :row_mouse_pointer="true"
              :boxStyle="boxStyle"
              :useFilter="true"
            ></lte-table>

            <div
              class="box-footer clearfix"
              style="display:contents;"
              v-if="has_perm('view_staff') || GET_ACCOUNT_DATA.id == 1"
            >
              <paginator :item="paginatorItem" @onpaginate="onPagination" />
            </div>

            <vue-good-table
              v-if="false"
              :columns="columns"
              :rows="rows"
              :select-options="{ enabled: false }"
              :search-options="{
                enabled: true,
                placeholder: $t('component_address_book.search')
              }"
              :line-numbers="true"
              :pagination-options="{
                enabled: true,
                nextLabel: $t('component_address_book.next'),
                prevLabel: $t('component_address_book.prev'),
                rowsPerPageLabel: $t('component_address_book.rows_per_page'),
                ofLabel: $t('component_address_book.of'),
                pageLabel: $t('component_address_book.page')
              }"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'customer_fullname'">
                  <span>{{
                    getFullName(
                      props.row.user_first_name,
                      props.row.user_last_name
                    )
                  }}</span>
                </span>
                <span v-else>{{ props.formattedRow[props.column.field] }}</span>
              </template>
            </vue-good-table>
          </div>
        </div>

        <!-- modal delete liabilities record -->
        <div
          class="modal fade"
          data-backdrop="static"
          id="modal-delete-liabilities-record"
        >
          <div class="modal-dialog" style="width:700px !important;">
            <div class="modal-content">
              <div class="modal-header">
                <h2 class="modal-title" style="text-align:left;">
                  {{ $t("delete_abilities.title") }}
                </h2>
              </div>
              <div class="modal-body">
                <p>{{ $t("delete_abilities.context_pick") }}</p>
                <div>
                  <label for="name" class="form--apartmentcode">{{
                    $t("delete_abilities.apartment_code")
                  }}</label>
                  <b-form-select
                    class="form--select"
                    v-model="selected"
                    :options="options"
                  ></b-form-select>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-primary btn-sm pull-right mg-left"
                  @click="ConfirmRemoveliabilitiesRecord"
                >
                  {{ $t("common.delete") }}
                </button>
                <button
                  type="button"
                  class="btn btn-warning btn-sm pull-left"
                  @click="closeModal"
                >
                  {{ $t("common.back") }}
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
        </div>

        <!-- modal confirm delete liability confirm -->
        <div
          class="modal fade"
          data-backdrop="static"
          id="modal-confirm-delete-liabilities-record"
        >
          <div class="modal-dialog" style="width:700px !important;">
            <div class="modal-content">
              <div class="modal-header">
                <h2 class="modal-title" style="text-align:left;">
                  {{ $t("delete_abilities.confirm") }}
                </h2>
              </div>
              <div class="modal-body">
                <h3 v-if="this.selected == null">
                  {{ $t("delete_abilities.unpick_liabilities") }}
                </h3>
                <div v-else>
                  <h4>
                    {{
                      $t("delete_abilities.content_confirm_delete_liabilities")
                    }}
                    {{ apartment_code }} ?
                  </h4>
                  <h4>
                    {{ $t("delete_abilities.content_confirm_delete_include") }}
                  </h4>
                  <div style="padding-left: 3rem;">
                    <p>{{ $t("delete_abilities.receipt_info") }}</p>
                    <p>{{ $t("delete_abilities.report_info") }}</p>
                    <p>{{ $t("delete_abilities.old_liabilities") }}</p>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-primary btn-sm pull-right mg-left"
                  @click="RemoveliabilitiesRecord"
                >
                  {{ $t("common.delete") }}
                </button>
                <button
                  type="button"
                  class="btn btn-warning btn-sm pull-left"
                  @click="closeModalConfirm"
                >
                  {{ $t("common.back") }}
                </button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
        </div>

        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>

    <modal-delete-liabilitiy
      ref="onShowModalDeleteLiability"
      @callBackActionDeleteLiability="callBackActionDeleteLiability"
    ></modal-delete-liabilitiy>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import LTEChart from '@/components/LTEChart'
import LTETable from "@/components/LTETable.vue";
import LTEButton from "@/components/LTEButton.vue";
import Loading from "vue-loading-overlay";
import Paginator from "@/components/Paginator.vue";
// import datePicker from "vue-bootstrap-datetimepicker";
// // import DateRangePicker2 from '@/components/LTEDateRangePicker2.vue'
// import Select2 from '@/components/LTESelect2Input.vue'

// import XLSX from "xlsx";
// import moment from 'moment'

// import vue-good-table
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import ModalDeleteLiability from "./ModalDeleteLiability";

// vue-input-tag
// import InputTag from "vue-input-tag";
import utils from '@/lib/utils';
import i18n from "../../lang";

export default {
  name: "AccountingHomeLiabilityList",
  data() {
    return {
      selected: null,
      options: [
        {
          value: null,
          text: "Please select an option"
        }
      ],
      apartment_code: null,
      gridDataList: [],
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;",
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "accounting_home_liability.customer_code", isHidden: true },
        { text: "accounting_home_liability.customer_fullname", isHidden: true },
        { text: "accounting_home_liability.apartment_code", isHidden: true },
        { text: "accounting_home_liability.invoice_code", isHidden: true },
        { text: "accounting_home_liability.explaination", isHidden: true },
        { text: "accounting_home_liability.cash", isHidden: true },
        {
          text: "accounting_home_liability.closing_trade_payable",
          isHidden: true
        }
        // { text: "accounting_home_liability.date", isHidden: true },
      ],
      boxStyle: false,
      paginatorItem: {
        commit_function: "GET_ACCOUNTING_HOME_LIABILITY_LIST"
      },

      // Mã KH, Tên KH, Mã Căn, Mã Chứng Từ, Diễn Giải, Số Tiền, Số Dư
      columns: [
        {
          label: this.$t("accounting_home_liability.customer_code"),
          field: "customer_code"
        },
        {
          label: this.$t("accounting_home_liability.customer_fullname"),
          field: "customer_fullname"
        },
        {
          label: this.$t("accounting_home_liability.apartment_code"),
          field: "apartment_code"
        },
        {
          label: this.$t("accounting_home_liability.invoice_code"),
          field: "invoice_code"
        },
        {
          label: this.$t("accounting_home_liability.explaination"),
          field: "explaination"
        },
        {
          label: this.$t("accounting_home_liability.cash"),
          field: "cash"
        },
        {
          label: this.$t("accounting_home_liability.closing_trade_payable"),
          field: "closing_trade_payable"
        },
        {
          label: this.$t("accounting_home_liability.date"),
          field: "date"
        }
      ],
      rows: [],

      isLoading: false
    };
  },
  watch: {
    GET_APARTMENT_FROM_ACCOUTINGHOMEBALANCE_DATA: function() {
      this.options = [];
      this.GET_APARTMENT_FROM_ACCOUTINGHOMEBALANCE_DATA.forEach(apartment => {
        let value = apartment.id;
        let text = apartment.apartment.apartment_code;
        let apartment_id = apartment.apartment.id;
        let data = {
          value: value,
          text: text,
          apartment_id: apartment_id
        };
        this.options.push(data);
      });
    },
    accounting_home_liability_data: function() {
      this.rows = this.accounting_home_liability_data;

      this.gridDataList = [];
      this.accounting_home_liability_data.forEach((item, i) => {
        let id = item.id;
        let nonumber = i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let customer_code = item.customer_code;
        let customer_fullname = this.getFullName(item.user_first_name, item.user_last_name);
        let apartment_code = item.apartment_code;
        let invoice_code = item.invoice_code;
        let explaination = item.explaination;
        let cash = utils.formatNumber(utils.makeRoundNumber(item.cash));
        let closing_trade_payable = utils.formatNumber(utils.makeRoundNumber(item.closing_trade_payable));
        let date = utils.addTimeZoneForTimestamp(item.date, "DD/MM/YYYY");

        let data = {
          id: id,
          "common.nonumber": nonumber,
          "accounting_home_liability.customer_code": customer_code,
          "accounting_home_liability.customer_fullname": customer_fullname,
          "accounting_home_liability.apartment_code": apartment_code,
          "accounting_home_liability.invoice_code": invoice_code,
          "accounting_home_liability.explaination": explaination,
          "accounting_home_liability.cash": cash,
          "accounting_home_liability.closing_trade_payable": closing_trade_payable,
          "accounting_home_liability.date": date
        };
        this.gridDataList.push(data);
      });
    }
  },
  computed: {
    ...mapGetters("accountingHomeLiabilityModule", {
      accounting_home_liability_data: "ACCOUNTING_HOME_LIABILITY_LIST"
    }),
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ACCOUNT_DATA",
      "GET_APARTMENT_FROM_ACCOUTINGHOMEBALANCE_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    getFullName(firstname, lastname) {
      return utils.getFullName(firstname, lastname, i18n.locale);
    },
    /*
     * author : [loitt]
     * function: call BackAction Delete Liability
     *       Refresh data after delete
     */
    callBackActionDeleteLiability: async function() {
      // reload full page
      const data = {
        params: {
          page: 1
        }
      };
      await this.GET_ACCOUNTING_HOME_LIABILITY_LIST(data);
      this.$router.go(0);
    },

    /*
     * author : [loitt]
     * function: Show modal delete Liability
     */
    onShowModalDeleteLiability: function() {
      this.$refs.onShowModalDeleteLiability.submit();
    },

    importExcel: function() {
      this.$router.push({
        name: "AccountingHomeLiabilityImportExcel",
        params: {
          id: 0
        }
      });
    },
    onShowModalRemoveliabilitiesRecord: function() {
      this.GET_APARTMENT_FROM_ACCOUTINGHOMEBALANCE();
      $("#modal-delete-liabilities-record").modal("show");
    },

    closeModal: function() {
      $("#modal-delete-liabilities-record").modal("hide");
    },
    closeModalConfirm: function() {
      $("#modal-confirm-delete-liabilities-record").modal("hide");
      $("#modal-delete-liabilities-record").modal("show");
    },
    ConfirmRemoveliabilitiesRecord: function() {
      $("#modal-delete-liabilities-record").modal("hide");
      $("#modal-confirm-delete-liabilities-record").modal("show");
      this.options.forEach(el => {
        if (this.selected == el.value) {
          this.apartment_code = el.text;
        }
      });
    },

    RemoveliabilitiesRecord: function() {
      if (this.selected == null || this.selected == "") {
        this.ON_SHOW_TOAST({
          message: this.$t("delete_abilities.unpick_liabilities"),
          styleType: "danger"
        });
        return;
      }
      this.options.forEach(el => {
        if (this.selected == el.value) {
          let data = {
            accountinghomebalance_id: el.value,
            apartment_id: el.apartment_id
          };
          this.DELETE_LIABILITY_RECORD(data)
            .then(
              function(res) {
                this.GET_APARTMENT_FROM_ACCOUTINGHOMEBALANCE();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ERROR_TOAST({
                  message: error,
                  styleType: "danger"
                });
              }.bind(this)
            );
          $("#modal-confirm-delete-liabilities-record").modal("hide");
          this.selected = null;
        }
      });
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_ACCOUNTING_HOME_LIABILITY_LIST"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_ACCOUNTING_HOME_LIABILITY_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(data) {
      this.GET_ACCOUNTING_HOME_LIABILITY_LIST(data);
    },

    ...mapActions("accountingHomeLiabilityModule", [
      "GET_ACCOUNTING_HOME_LIABILITY_LIST"
    ]),
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_APARTMENT_FROM_ACCOUTINGHOMEBALANCE",
      "DELETE_LIABILITY_RECORD",
      "ON_SHOW_TOAST"
    ])
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };
    this.GET_ACCOUNTING_HOME_LIABILITY_LIST(data);
  },
  components: {
    "vue-good-table": VueGoodTable,
    "lte-button": LTEButton,
    loading: Loading,
    "modal-delete-liabilitiy": ModalDeleteLiability,

    "lte-table": LTETable,
    paginator: Paginator
  }
};
</script>
<style scoped>
.form--apartmentcode {
  margin-right: 4rem;
}
.form--select {
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Report/AccountingHomeLiabilityList.vue